@if (breadcrumbItem()) {
  <div class="tag-notification flex gap-2">
    @if (route()) {
      <a [routerLink]="route()">{{ label() ?? '' }}</a>
    } @else {
      <div class="font-bold">
        {{ label() ?? '' }}
      </div>
    }
    @if (actions()) {
      <div>
        <div class="cursor-pointer" (click)="menu.toggle($event)">
          <i class="fas fa-chevron-down"></i>
        </div>
        <p-menu #menu [model]="actions()" [popup]="true" appendTo="body"/>
      </div>
    }
  </div>
}
